<template>
	<div>
    <content-data v-if="is_settings" :list="list_id" editpath="/devices/locations/list/" :disable-import="true" :search="data_search"></content-data>
    <v-btn class="deep-orange" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add"><v-icon>add</v-icon></v-btn>

    <v-toolbar color="grey darken-4" fixed dense right style="top: 87px; left: auto; right: 80px; max-width: 300px;">
      <v-text-field color="deep-orange" prepend-icon="search" v-model="data_search" ref="search_field" autofocus clearable hide-details single-line></v-text-field>
    </v-toolbar>

  </div>
</template>

<script>
import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';

export default {
	components: {
		ContentData,
	},
  data () {
    return {
      data_search: ""
    }
  },
  methods:{
    open_add() {
      this.$router.push("/devices/locations/list/" + this.list_id + "/data/new");
    }
  },
  mounted () {
    this.$refs.search_field.focus();
  },
  computed: {
    is_settings() {
      if (this.settings.length > 0) return true;
      return false;
    },
    settings () {
      return SettingsModel.list("device_type");
    },
    list_id() {
      return this.settings[0].value.location_list_id;
    }
  }
}
</script>